import { useWatch } from 'react-hook-form'

import s from './Header.module.scss'
import type { HeaderProps } from './Header.props'

export function Header({ data }: HeaderProps) {
  const name = useWatch({ name: 'name' })

  return (
    <div className={s.header}>
      <h1
        className={s.title}
        dangerouslySetInnerHTML={{ __html: data.title.replace('[name]', name) }}
      />

      {data?.achievements?.length && (
        <ul className={s.list}>
          {data.achievements.map((achievement, index) => (
            <li
              key={index}
              className={s.item}
            >
              {achievement?.icon && (
                <img
                  src={achievement.icon}
                  alt="Icon"
                  width={27}
                  height={40}
                  className={s.icon}
                />
              )}
              {achievement?.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
